var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDashboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 7.5C5 6.6875 5.65625 6 6.5 6H9.5C10.3125 6 11 6.6875 11 7.5V12.5C11 13.3438 10.3125 14 9.5 14H6.5C5.65625 14 5 13.3438 5 12.5V7.5ZM6.5 12.5H9.5V7.5H6.5V12.5ZM13 13.5C13 12.6875 13.6562 12 14.5 12H17.5C18.3125 12 19 12.6875 19 13.5V18.5C19 19.3438 18.3125 20 17.5 20H14.5C13.6562 20 13 19.3438 13 18.5V13.5ZM14.5 18.5H17.5V13.5H14.5V18.5ZM9.5 15C10.3125 15 11 15.6875 11 16.5V18.5C11 19.3438 10.3125 20 9.5 20H6.5C5.65625 20 5 19.3438 5 18.5V16.5C5 15.6875 5.65625 15 6.5 15H9.5ZM9.5 16.5H6.5V18.5H9.5V16.5ZM13 7.5C13 6.6875 13.6562 6 14.5 6H17.5C18.3125 6 19 6.6875 19 7.5V9.5C19 10.3438 18.3125 11 17.5 11H14.5C13.6562 11 13 10.3438 13 9.5V7.5ZM14.5 9.5H17.5V7.5H14.5V9.5Z",
    fill: "#0D3338"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboard);
export default __webpack_public_path__ + "static/media/Dashboard.18b6fc302da76fef563773c592e753cb.svg";
export { ForwardRef as ReactComponent };